export default "__VITE_ASSET__D_j7TTUX__"